export default {
    path: '/',
    name: 'RedZone',
    component: resolve => require(['@/views/redZone'], resolve),
    redirect: '/redZone', 
    children: [
        {
            path: '/redZone',
            name: 'redZone',
            meta: [{
                path: '/redZone',
                title: '报告',
                color: "#f2f2f2"
            }],
            component: resolve => require(['@/views/redZone.vue'], resolve),
        },
    ],
}